import { SecondaryButton } from "@digipost/dds-buttons-react";
import { faArrowRightFromBracket } from "@fortawesome/pro-regular-svg-icons/faArrowRightFromBracket";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { useSelector } from "react-redux";

import { User } from "../../../types/session";
import PostenLogo from "../../assets/images/logo/digipost-posten-logo.svg";
import PostenLogoLiten from "../../assets/images/logo/digipost-posten-logo-liten.svg";
import {
  SiteImproveActions,
  SiteImproveCategories,
  siteImproveEvent,
} from "../analytics/SiteImprove";
import { isMobilapp } from "../infrastructure/mobilapp";
import { ReduxState } from "../infrastructure/redux/state";
import Translated from "../infrastructure/Translated";

type Props = {
  logout: () => void;
  user?: Partial<User>;
  authOK: boolean;
  forsideLink: string;
};

const DigipostHeader: FC<Props> = ({ forsideLink, authOK, logout, user }) => {
  const mode = useSelector((state: ReduxState) => state.app.mode);
  return (
    <header className={"header"}>
      <section className={"header-items-container"}>
        <a href={forsideLink} className={"header-logo-link"}>
          <img
            src={PostenLogo}
            alt={"Logo: Digipost"}
            className={"logo-digipost logo-desktop"}
          />
          <img
            src={PostenLogoLiten}
            alt={"Logo: Digipost"}
            className={"logo-digipost logo-mobile"}
          />
        </a>
      </section>
      <section className={"header-items-container"}>
        {authOK && user && (
          <>
            <div className={"header-link enabled"}>
              <span>{`${user.firstName ?? ""} ${user.lastName ?? ""}`}</span>
            </div>
            {!isMobilapp() && (
              <div className="logout-button">
                <SecondaryButton
                  className="header-item"
                  onClick={() => {
                    siteImproveEvent({
                      category: SiteImproveCategories.GENERAL,
                      action: SiteImproveActions.LOGOUT,
                      label: `/${mode}`,
                    });
                    return logout();
                  }}
                >
                  <FontAwesomeIcon icon={faArrowRightFromBracket} />
                  <Translated textKey={"generic.logout"} />
                </SecondaryButton>
              </div>
            )}
          </>
        )}
      </section>
    </header>
  );
};

export default DigipostHeader;
